module.exports = __webpack_public_path__ + "static/baby-2@2x-9008307b488ce06d4464d752cbde17b3.jpg";